export default "__VITE_ASSET__hi1Yo0$n__"